import AuthFormSignup from "../../components/Auth/AuthFormSignup";
import TemplateAuthentication from "../../components/UI/TemplateAuthentication";

interface SignupPageProps {
  pro?: boolean;
}

export default function SignupPage({ pro = false }: SignupPageProps) {
  return (
    <TemplateAuthentication>
      <AuthFormSignup pro={pro} />
    </TemplateAuthentication>
  );
}
